const RETRYABLE_REASONS = ['invalid_upload', 'exception']

export function partitionAttachedRefs (failed, attachedPhotoRefs, attachedByKey) {
  const list = Array.isArray(failed) ? failed : []
  const retryable = list.filter((f) => f && RETRYABLE_REASONS.includes(f.reason))
  const retryableRefs = []
  for (const f of retryable) {
    const ref = attachedByKey && attachedByKey.get(`${f.item_id}:${f.type}`)
    if (ref) retryableRefs.push(ref)
  }
  const blocked = new Set(retryableRefs)
  const sealRefs = (attachedPhotoRefs || []).filter((ref) => !blocked.has(ref))
  return { sealRefs, retryable, retryableRefs }
}

export function buildFailedAddonsError (refs) {
  return new Error(
    `save-offline-answers-copy 2xx con ${refs.length} addon(s) en failed (refs: ${refs.slice(0, 5).join(',')})`
  )
}
